import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-hansewerk-storungen',
  templateUrl: './hansewerk-storungen.component.html',
  styleUrls: ['./hansewerk-storungen.component.scss'],
})
export class HansewerkStorungenComponent {
  @Input() url!: string;
  @Input() isIE11 = false;

  constructor(private _router: Router) {}

  gotoDashboard() {
    this._router.navigateByUrl('/instrumententafel');
  }
}
